module.exports = "../images/cabin-4-person-3.jpg?v=de7a735";